module.exports = __webpack_public_path__ + "assets/rp-rain-delay-3543b4fb.png";